import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { useI18n } from '../../i18n/I18nProvider';
import ErrorLayout from '../../features/errors/pages/ErrorLayout';
import { PHOTOS } from '../../shared/ui/photos/photos';

/** How often the shell tries again by itself while Grow does not answer. */
export const SESSION_RETRY_MS = 15000;

/**
 * Shown when GET /api/users/me fails for a reason other than "not signed in" (a rate
 * limit, a deploy, the network). The person is still signed in, so this offers a retry,
 * and tries again by itself, instead of the sign-in page.
 */
export default function SessionUnavailable({ status, onRetry }: { status: number; onRetry: () => void }) {
  const { t } = useI18n();
  useEffect(() => {
    const timer = setTimeout(onRetry, SESSION_RETRY_MS);
    return () => clearTimeout(timer);
  }, [onRetry]);
  return (
    <ErrorLayout
      code={status === 429 ? '429' : '503'}
      photo={PHOTOS.offline}
      eyebrow={t('app.unavailable.eyebrow')}
      title={t('app.unavailable.title')}
      continuation={t(status === 429 ? 'app.unavailable.busy' : 'app.unavailable.body')}
      actions={<Button variant="contained" onClick={onRetry}>{t('app.unavailable.retry')}</Button>}
    />
  );
}
